import { render, staticRenderFns } from "./WaitingListConfigurationTemplates.vue?vue&type=template&id=4afc726a&"
import script from "./WaitingListConfigurationTemplates.vue?vue&type=script&lang=js&"
export * from "./WaitingListConfigurationTemplates.vue?vue&type=script&lang=js&"
import style0 from "./WaitingListConfigurationTemplates.vue?vue&type=style&index=0&id=4afc726a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports